"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = void 0;
var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/inheritsLoose"));
var _react = _interopRequireWildcard(require("react"));
var _navigationHeader = _interopRequireDefault(require("../styles/navigation-header.css"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var LinkItem = /*#__PURE__*/function (_PureComponent) {
  (0, _inheritsLoose2["default"])(LinkItem, _PureComponent);
  function LinkItem() {
    return _PureComponent.apply(this, arguments) || this;
  }
  var _proto = LinkItem.prototype;
  _proto.render = function render() {
    var _this$props = this.props,
      classes = _this$props.classes,
      anchorClasses = _this$props.anchorClasses,
      url = _this$props.url,
      keyHandler = _this$props.keyHandler,
      focusHandler = _this$props.focusHandler,
      children = _this$props.children,
      theme = _this$props.theme,
      clickHandler = _this$props.clickHandler;
    var addedClasses = classes.map(function (currentClass) {
      return _navigationHeader["default"][currentClass];
    });
    return /*#__PURE__*/_react["default"].createElement("li", {
      className: addedClasses.join(' ') + " menu-panel-sub-list-item",
      role: "menuitem"
    }, /*#__PURE__*/_react["default"].createElement("a", {
      className: theme.labelSmall + " " + _navigationHeader["default"].bottomLinks + " " + (anchorClasses ? anchorClasses.join(' ') : ''),
      href: url,
      onKeyDown: keyHandler,
      onFocus: focusHandler,
      onClick: clickHandler
    }, children !== undefined && children));
  };
  return LinkItem;
}(_react.PureComponent);
exports["default"] = LinkItem;
LinkItem.displayName = 'LinkItem';
LinkItem.defaultProps = {
  classes: []
};